// UK company identifiers of a company's contract terms (tasks#211, user decision 2026-11-04).
// VAT number: 9 digits, e.g. 447249235. Company registration no.: the Companies House number, 8 characters,
// 8 digits (01234567) or 2 letters + 6 digits (SC123456). Empty values are left to the other rules.

const VAT_NUMBER = /^[0-9]{9}$/
const COMPANY_NUMBER = /^([0-9]{8}|[A-Z]{2}[0-9]{6})$/

// typed or stored spellings of a valid value: spaces, a "GB" prefix (prod holds 24 such VAT numbers)
export function normalizeVatNumber(value) {
    if (typeof value !== 'string') return value
    const compact = value.replace(/\s+/g, '').toUpperCase()
    const digits = compact.replace(/^GB/, '')
    return VAT_NUMBER.test(digits) ? digits : value
}

// spaces, lower-case letters, and the leading zero spreadsheets drop (prod holds 26 seven-digit numbers)
export function normalizeCompanyNumber(value) {
    if (typeof value !== 'string') return value
    const compact = value.replace(/\s+/g, '').toUpperCase()
    if (/^[0-9]{6,7}$/.test(compact)) return compact.padStart(8, '0')
    return COMPANY_NUMBER.test(compact) ? compact : value
}

export function isVatNumber(value) {
    return VAT_NUMBER.test(String(value))
}

export function isCompanyNumber(value) {
    return COMPANY_NUMBER.test(String(value))
}
